import * as yup from 'yup'
import { ValidationError } from 'yup'

export const inputHasError = (formErrors: ValidationError[], path: string) => {
    const result = formErrors?.length
        ? formErrors.find((error: yup.ValidationError) => error.path === path)
        : null
    return result != null
}
